import { useQuery } from 'react-query';

import { getActivityCodesByVersion as queryFn } from 'api/endPoints/getActivityCodesByVersion';
import { QueryKeys } from 'api/queryKeys';

export const useQueryActivityCodesByVersion = (params: Pick<QueryParams, 'latestVersion'>) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['activityCodesByVersion', params],
        queryFn: () => queryFn({ latestVersion: params.latestVersion as number }),
        enabled: Boolean(params.latestVersion),
    });
};

export const useQueryActivityCodesByVersionAndWidgetId = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['activityCodesForWidget', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.latestVersion) && Boolean(params.widgetId) && Boolean(params.hasActivityCode),
    });
};

export interface QueryResponse {
    alias: string | null;
    description: string;
    id: number;
    name: string;
    scope: string;
    typeName: string;
    typeUid: number;
    uid: number;
    activitiesCount: number;
    activtyCodeValueId: string;
}

interface QueryParams {
    latestVersion: number | undefined;
    widgetId: string | undefined;
    hasActivityCode: boolean | undefined;
}
